import AuthService from 'services/Auth';

export const aetherFetch = async (
  path: string,
  init: RequestInit = {},
): Promise<Response> => {
  const user = AuthService.getLocalUser?.();
  const graphqlUrl = window._env_.REACT_APP_GRAPHQL_API_URL;
  const apiBase = graphqlUrl.replace(/\/graphql\/?$/, '');

  const headers = new Headers(init.headers);
  if (!(init.body instanceof FormData) && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  headers.set('user-id', String(user?.id ?? ''));

  return fetch(`${apiBase}/api/aether/${path}`, { ...init, headers });
};
